import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
  avatar: {
    width: 200,
    height: 250,
  },
  iconButton: {
    padding: 10,
  },
}));

const Image = ({ data, file, setFile, setFieldValue }) => {
  const classes = useStyles();

  const [ image, setImage ] = React.useState(null);

  const handleSelectFile = (e) => {
    if (e.target.files.length === 0) return false;
    const files = Array.from(e.target.files);
    const reader = new FileReader();
    reader.onload = e => setImage(e.target.result);
    reader.readAsDataURL(files[0]);
    const formData = new FormData();
    formData.append('image', files[0]);
    setFile(formData);
    setFieldValue('image.src', '');
  };

  const getAvatarSrc = () => {
    if (file) return image;
    if (!data.image) return '';
    return data.image.url;
  };

  return (
    <>
      <Avatar
        variant="square"
        src={getAvatarSrc()}
        className={classes.avatar}
        style={{ marginBottom: 8 }}
      />
      <IconButton
        component="label"
        className={classes.iconButton}
      >
        <EditIcon />
        <input
          type="file"
          onChange={handleSelectFile}
          style={{ display: "none" }}
        />
      </IconButton>
    </>
  );
};

export default Image;
